import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Mission() {
  return <section id="mission" className="py-24 bg-pac-sand relative overflow-hidden" data-id="element-199" data-mp="4soitur87pcb">
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 rounded-full bg-pac-gold/10 blur-3xl" data-id="element-200" data-mp="jinfft34uspo" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-201" data-mp="ekc5zjgr2k7z">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-202" data-mp="3mykrk7kuuaqn">
          <div className="inline-flex items-center justify-center p-3 bg-pac-navy text-pac-gold rounded-full mb-6 shadow-lg" data-id="element-203" data-mp="3w0k86yryjct2">
            <ShieldCheck className="h-8 w-8" data-id="element-204" data-mp="3s0a5pw3dj4iy" />
          </div>
          <p className="text-pac-red font-bold uppercase tracking-[0.2em] text-sm mb-3" data-id="element-205" data-mp="1b8ii0rg04ewa">
            AZ City PAC
          </p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-pac-navy mb-6" data-id="element-206" data-mp="177otbvuqiw2c">
            Our Mission
          </h2>
          <p className="font-serif text-2xl md:text-3xl text-pac-navy leading-snug max-w-3xl mx-auto mb-10" data-id="element-207" data-mp="1n9atrpk9t44y">
            Arizona is not one community. It is hundreds. Each place has its own
            character, priorities, challenges, and promise.
          </p>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-slate-100 text-left" data-id="element-208" data-mp="1w9h5p70blw20">
            <div className="space-y-6 text-lg md:text-xl text-slate-700 leading-relaxed font-medium" data-id="element-209" data-mp="zlkuyirkduyp">
              <p data-id="element-210" data-mp="13j8trwwdo7vv">
                Local voices keep public decisions accountable to the people who
                live with the results. AZ City PAC is a statewide coalition of
                mayors, councilmembers, business leaders, and community
                advocates committed to protecting local decision-making and
                advancing policies that strengthen Arizona&apos;s cities and
                towns.
              </p>
              <p data-id="element-211" data-mp="1o57vbpueg3bq">
                We advocate for legislation that keeps decisions over zoning,
                land use, infrastructure, and community planning close to home
                while fostering responsible economic development, enhancing
                public safety, and protecting the quality of life of the
                residents we serve.
              </p>
              <p data-id="element-212" data-mp="156voiaqyn5jb">
                We support leaders who listen to communities, collaborate across
                the public, private, and nonprofit sectors, and protect the
                tools neighborhoods use to grow on their own terms — so power
                stays accountable and lasting freedom is preserved at every
                level of government.
              </p>
              <p className="text-pac-navy" data-id="element-213" data-mp="19al6ghd4qovd">
                Our mission is to unite Arizona&apos;s municipal leaders and
                stakeholders to champion policies that create strong local
                economies, resilient infrastructure, safe neighborhoods, and
                thriving communities for generations to come.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}